module.exports = __webpack_public_path__ + "static/media/nav.sketches.6ca57508.png";